<template>
<div class="c-subscription">
    <h4>{{heading}}</h4>
    <p> We are becoming SoftwareOne please visit <a href="https://www.softwareone.com" >SoftwareOne</a></p>
</div>
</template>

<script>
import Button from '@/Scripts/components/atoms/Button.vue';
export default {
    props: ['heading'],
    data: function () {
        return {
            statusSubscribedMessage: '',
            subscribeIsSuccess: false,
            submitButtonDisabled: false,
        };
    },
    components: {
        Button
    },
    mounted() {
        //adding recaptcha script
        let recaptchaScript = document.createElement('script');
        recaptchaScript.setAttribute('src', 'https://www.google.com/recaptcha/api.js');
        document.head.appendChild(recaptchaScript);
    },
    methods:
    {
        hideStatusMessageafterDelay() {
            let self = this;
            setTimeout(() => {
                self.statusSubscribedMessage = '';
            }, 8000);
        },
        disableSubmitButton() {
            this.submitButtonDisabled = true;
        },
        submitForm() {
            let form = document.forms.PageForm;
            let formData = new FormData(form);
            let xhr = new XMLHttpRequest();
            const self = this;
            xhr.open('POST', 'https://publish.ne.cision.com/Subscription/SubscribeWithCaptcha', true);
            xhr.onload = function () {
                if (xhr.status === 200) {
                    self.statusSubscribedMessage = 'Succsess! You will recive an email to verify your email address and activate the subscription.';
                    self.subscribeIsSuccess = true;
                    self.disableSubmitButton();
                } else {
                    self.statusSubscribedMessage = 'Error! Something went wrong';
                    self.subscribeIsSuccess = false;
                }
            };
            xhr.send(formData);
            this.hideStatusMessageafterDelay();
        }
    }

};
</script>

<style lang="scss">
.c-subscription {
        &-item {
            margin-bottom: 1em;
        }
        &__statusTextSuccess {
            color: green;
        }
        &__statusTextError {
            color: $orange;
        }
    }
</style>
